import './App.scss';

import { HelmetProvider } from 'react-helmet-async';

import { InteractionType } from '@azure/msal-browser';
import {
  MsalAuthenticationTemplate,
  useIsAuthenticated,
} from '@azure/msal-react';
import { ThemeProvider } from '@mui/material';

import { NoMandantsAssigned } from './features/mandant/components/NoMandantsAssigned/NoMandantsAssigned';
import { useGetMandants } from './features/shared/hooks/use-get-mandants/use-get-mandants.hook';
import { useSetMandant } from './features/shared/hooks/use-set-mandant/use-set-mandant.hook';
import { RoutesRenderer } from './features/shared/utils/routes-renderer/routes-renderer.util';
import { PageHead } from './shared/components/page-head/page-head';
import { globalTheme } from './shared/theme/theme';

function App() {
  const isAuthenticated = useIsAuthenticated();
  const mandants = useGetMandants();

  useSetMandant();

  return (
    <>
      <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
        <ThemeProvider theme={globalTheme}>
          <HelmetProvider>
            <PageHead />
            {isAuthenticated && mandants && mandants.length > 0 && (
              <RoutesRenderer />
            )}
            {isAuthenticated && mandants && mandants.length === 0 && (
              <NoMandantsAssigned />
            )}
          </HelmetProvider>
        </ThemeProvider>
      </MsalAuthenticationTemplate>
    </>
  );
}

export default App;
